export const TypificationDepthLevel = {
  untilGroups: 1,
  untilResults: 2,
  untilMotives: 3,
  untilSubmotives: 4,
};

export const IvrDerivation = {
  informative: 1,
  withReturn: 2,
};
export const TypeAssignment = {
  random: 1,
  byAssignment: 2,
};

export const StrategyOriginTypes = Object.freeze({
  1: "Por filtro",
  2: "Por plantilla",
});

export const LaunchErrorType = Object.freeze({
  UserOnCurrentLaunched: "users",
  WabaAlreadyLaunched: "whatsapp_another_launched",
  TierLimit: "whatsapp_tier_limit",
  InsufficientBalance: "turned_on:No cuenta con saldo para lanzar una estrategia de SMS",
  UsersValidation: "users_validation",
});

export const TypeCharge = {
  PersonalizedParameters: 2,
  ChargeParameters: 1,
}